import styled, { css } from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { CLASS_COMPONENT } from '../../common';

export const CheckoutFormWrapper = styled.div.attrs<{
  $color: string;
  $disabled?: boolean;
}>(() => ({
  className: createReadableClass({
    component: CLASS_COMPONENT,
    element: 'wrapper'
  })
}))`
  display: flex;
  flex-direction: column;

  color: ${({ $color }) => $color};
  fill: ${({ $color }) => $color};

  ${({ $disabled = false }) =>
    $disabled &&
    css`
      pointer-events: none;
    `}
`;
